import { Component, OnInit } from "@angular/core";
import { RequestCreationFormService } from "@fiduciaria/RequestCreation/Services/request-creation-form.service";
import { UploadMultipleFilesService } from "@fiduciaria/RequestCreation/Services/upload-multiple-files.service";
import { DocumentFile } from "@fiduciaria/RequestCreation/Types/document-file";
import { DocumentFileGroup } from "@fiduciaria/RequestCreation/Types/document-file-group";
import { CreationRequest, CreationResponse } from "@fiduciaria/RequestCreation/Types/Interfaces/new-request-creation.interface";
import { Observable } from "rxjs";

@Component({
  selector: "app-confirmation",
  templateUrl: "./confirmation.component.html",
})
export class ConfirmationComponent implements OnInit {
  public response$: Observable<CreationResponse>;
  public newRequest$: Observable<CreationRequest>;

  constructor(
    private requestCreationForm: RequestCreationFormService,
    private uploadMultipleFilesService: UploadMultipleFilesService
  ) {}

  public ngOnInit(): void {
    this.response$ = this.requestCreationForm.response;
    this.newRequest$ = this.requestCreationForm.value;
  }

  private getRequestFilesGroups(requestFiles: DocumentFile[]): DocumentFileGroup[] {
    requestFiles = requestFiles ?? [];
    return this.uploadMultipleFilesService.groupFilesByReferenceName(requestFiles);
  }

  private getSizeMegaBytes(bytes: number, digits: number): number {
    return this.uploadMultipleFilesService.getSizeMegaBytes(bytes, digits);
  }

  private getFilesSizeMegaBytes1X1(files: DocumentFile[], digits: number): number {
    return this.uploadMultipleFilesService.getFilesSizeMegaBytes1X1(files, digits);
  }

  public onNewRequest(): void {
    this.requestCreationForm.resetForm();
  }
}
